import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=2ee2315e&"
import script from "./detail-dialog.vue?vue&type=script&lang=js&"
export * from "./detail-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports